import React from 'react'
import t from '../../../i18n/login'

const SmsCode = props => {
    const {
        smsCode, smsCodeError, secs,
        onSmsCodeChange, onSmsCodeKeyDown, onSmsCodeBlur, onSendSmsCode,
     } = props

    const sendCodeBtn = secs === 0
            ? <a href="javascript:" className="btn-oc btn-oc-code" onClick={(e) => onSendSmsCode(e)}>{t('get_imgcode')}</a>
            : <a href="javascript:" className="btn-oc btn-oc-code btn-oc-disable">{secs}{t('get_imgcode_after')}</a>

    return (
        <div className="oc-inp">
            <div className="oc-inpbox oc-inpbox-code">
                <input className="oc-inptxt" type="text" value={smsCode} placeholder={t('phone_verify')} maxLength="6" onChange={(e) => onSmsCodeChange(e)} onKeyDown={(e) => onSmsCodeKeyDown(e)} onBlur={() => onSmsCodeBlur()}/>
            </div>
            <p className="oc-err">{smsCodeError}</p>
            {sendCodeBtn}
        </div>
    )
}

export default SmsCode



// WEBPACK FOOTER //
// ./js/src/pages/Login/components/SmsCode.jsx